import React, { Component, ComponentType } from 'react';

import AuthButtonComponent from './AuthButtonComponent';
import ChallengeRequestProps from '../challenge-request/ChallengeRequestProps';
import { ChallengeResult } from '../../../modules/challenge';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons';

type State = {
};

export default class AuthButtonContainer<P, S> extends Component<P & Props, S & State> {
  static icon = faAsterisk
  static authname = "Generic Authentication Method"
  static description = "Authenticate via generic auth"
  static authLevel = 0

  static challengeRequestComponent: ComponentType<ChallengeRequestProps>

  get enrolled() {
    return false;
  }

  get required() {
    return false;
  }

  handleOnClick() {
    let CRC = (this.constructor as typeof AuthButtonContainer).challengeRequestComponent

    this.props.setChallengeRequestComponent(
      <CRC challengeResponse={this.handleChallengeResponse.bind(this)}></CRC>
    )
  }

  handleChallengeResponse(result: ChallengeResult) {
    this.props.challengeResponse(result)
  }

  render() {
    let childClass = (this.constructor as typeof AuthButtonContainer)
    return (
      <AuthButtonComponent
        onClick={this.handleOnClick.bind(this)}
        loading={this.props.loading}
        icon={childClass.icon}
        name={childClass.authname}
        description={childClass.description}
        isEnrolled={this.enrolled}
        isRequired={this.required} />
    )
  }
}

interface Props {
  loading: boolean
  challenge: any
  setChallengeRequestComponent: (c: JSX.Element | null) => void
  challengeResponse: (result: ChallengeResult) => void
}